import { deleteImageEl, getImageEl, setImageEl } from "../../../store/imageStore";
import { updateLayer } from "../layerStore";
import { LayerData } from "./layerData.model";

export class ImageLayerData extends LayerData {

  source: string;
  maintain_aspect_ratio: boolean = false;

  constructor(data?: Partial<ImageLayerData>) {
    super(data);
    this.source = data?.source || "";
    this.type = data?.type || "image";

    const cachedImage = getImageEl(this.id)

    if (cachedImage === undefined) {
      const img = new window.Image()
      img.onload = () => {
        if (!data?.size_w) {
          updateLayer(this.id, "size_w", img.naturalWidth);
          updateLayer(this.id, "size_h", img.naturalHeight);
        }
      }
      img.onerror = () => {
        console.warn(`Failed to load image for layer ${this.id}: ${this.source}`);
        deleteImageEl(this.id);
      }

      img.src = this.source
      img.crossOrigin = 'Anonymous'

      setImageEl(this.id, img);
    }


  }
}
